// "GENERATING…" / "RUNNING SIM…" / etc. animated ellipsis that's used
// across the admin job-status UI. Kept as a stand-alone component so
// CardEditor / NpcDeckEditor / AdminPage don't each carry their own
// copy that drifts in interval / dot count.

import { useEffect, useState } from "react";

export function AnimatedEllipsis({ label }: { label: string }) {
  const [n, setN] = useState(1);
  useEffect(() => {
    const id = setInterval(() => setN((x) => (x % 3) + 1), 400);
    return () => clearInterval(id);
  }, []);
  return (
    <span>
      {label}
      {".".repeat(n)}
      {/* Reserve width for the trailing dots so the parent doesn't
          jitter as the count rolls over each tick. */}
      <span style={{ visibility: "hidden" }}>{".".repeat(3 - n)}</span>
    </span>
  );
}
